import {
  type HistoryGroup,
  getHistoryId,
  getOrderStatusUpdate,
  isHistoryGroup,
} from "@/features/history/utils";
import { useModals } from "@/features/modals/hooks";
import { type History, useOrder } from "@repo/api";
import { LightMode, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { SimpleLabelField } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
}

export const OrderHistoryDescription = ({
  history,
}: {
  history: History | HistoryGroup;
}) => {
  const orderStatusUpdate = getOrderStatusUpdate(history);
  const showBody = !orderStatusUpdate;

  return (
    <div>
      {showBody && <Text textStyle="Body.S">{history.body}</Text>}
      <Text textStyle="Body.S">{history.note}</Text>
      {history.details?.order_number && (
        <SimpleLabelField
          small
          label={t("label.order_id")}
          value={history.details.order_number}
          color={LightMode.colourTextAndIcon2}
        />
      )}
      {orderStatusUpdate && <Text textStyle="Body.S">{orderStatusUpdate}</Text>}
    </div>
  );
};

export const OrderHistoryItem = ({ history }: Props) => {
  const { pushModal } = useModals();

  const historyEntries = isHistoryGroup(history)
    ? history.prevEntries
    : undefined;

  const entryId = history.details?.order_number ?? getHistoryId(history);

  const { data: order } = useOrder(entryId);

  return (
    <HistoryListViewItem
      history={history}
      control={order ? "navigational" : "default"}
      onClick={() => {
        if (order) {
          pushModal({
            type: "ORDER",
            orderId: order.orderNo,
            historyEntries,
          });
        }
        trackAnalytics("order_history");
      }}
      title={history.title}
      description={<OrderHistoryDescription history={history} />}
    />
  );
};
